import { requestPolicyExchange } from "@urql/exchange-request-policy";

export const QUERY_REVALIDATION_TTL_MS = 30 * 60 * 1000;

/**
 * Upgrades a `cache-first` query to `cache-and-network` once its last network result is older
 * than the TTL. The clock is per operation (document + variables) and only a network result
 * resets it, never a cache hit. It lives inside the urql client, so a rebuilt client starts every
 * query as expired. Graphcache itself never expires entries.
 */
export const queryRevalidationExchange = requestPolicyExchange({ ttl: QUERY_REVALIDATION_TTL_MS });
